// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 12206-根据商品ID查询生效中的价格详情 GET /web/v1/goodsPriceDayly/activeDetailByGoodsId/${param0} */
export async function activeDetailByGoodsId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.activeDetailByGoodsIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGoodsPriceDaylyVersionDetailVo>(
    `/web/v1/goodsPriceDayly/activeDetailByGoodsId/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 12203-新增商品价格版本 POST /web/v1/goodsPriceDayly/add */
export async function addPriceDaylyVersion(
  body: API.SwimGoodsPriceDaylyVersionUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/goodsPriceDayly/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 12205-删除商品价格版本 POST /web/v1/goodsPriceDayly/delete/${param0} */
export async function deletePriceDaylyVersion(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deletePriceDaylyVersionParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(
    `/web/v1/goodsPriceDayly/delete/${param0}`,
    {
      method: 'POST',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 12202-查询商品价格版本详情 GET /web/v1/goodsPriceDayly/detail/${param0} */
export async function getPriceDaylyVersionDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPriceDaylyVersionDetailParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGoodsPriceDaylyVersionDetailVo>(
    `/web/v1/goodsPriceDayly/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 12201-分页查询商品价格版本列表 POST /web/v1/goodsPriceDayly/pageList */
export async function getPriceDaylyVersionPageList(
  body: API.SwimGoodsPriceDaylyVersionPageQueryVo,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOYmPageResVOSwimGoodsPriceDaylyVersionListVo>(
    '/web/v1/goodsPriceDayly/pageList',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 12204-修改商品价格版本 POST /web/v1/goodsPriceDayly/update */
export async function updatePriceDaylyVersion(
  body: API.SwimGoodsPriceDaylyVersionUpdateReqVO,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/goodsPriceDayly/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
